import axios from "axios";

const instance = axios.create({
    baseURL: process.env.REACT_APP_HOST_API || "http://localhost:8080",
    headers: {
        "Content-type": "application/json",
    },
});

instance.interceptors.request.use(
    (config) => {
        // Gateway APIs require these headers on many endpoints.
        // Add them centrally to avoid missing-header 500s.
        try {
            const docplaceRaw = localStorage.getItem("docplace");
            const docplace = docplaceRaw ? JSON.parse(docplaceRaw) : null;
            const customerId = docplace?.customerId;
            const userId = docplace?.userId;

            config.headers = config.headers || {};

            // Normalize: axios headers object may be case-insensitive, but we set the canonical names.
            if (customerId && !config.headers["x-client-id"]) {
                config.headers["x-client-id"] = customerId;
            }
            if (userId && !config.headers["x-user-id"]) {
                config.headers["x-user-id"] = userId;
            }
        } catch {
            // Ignore header enrichment errors; request will proceed.
        }

        return config;
    },
    (error) => Promise.reject(error)
);

export default instance;
